import { APIResponseType } from 'app/apiService/types';
import apiService from '..';

export interface Tag {
  _id: string;
  name: string;
  type: string;
  createdAt: string;
  updatedAt: string;
}

export interface TagResponse {
  data: Tag[];
  meta: {
    totalDocuments: number;
    totalPages: number;
    currentPage: number;
  };
}

export interface CreateTagRequest {
  name: string;
  type: string;

}

export interface UpdateTagRequest {
  name?: string;
  type: string;
}

class TagApiService {
  static ENDPOINT = 'api/v2/tag';

  static async getTags(params?: {
    skip?: number;
    limit?: number;
    type?: string;
  }): Promise<APIResponseType<TagResponse>> {
    try {
      const cleanParams = {
        ...params,
      };

      const response = await apiService.get<APIResponseType<TagResponse>>(
        this.ENDPOINT,
        cleanParams
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async getTagById(id: string): Promise<APIResponseType<Tag>> {
    try {
      const response = await apiService.get<APIResponseType<Tag>>(
        `${this.ENDPOINT}/${id}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async createTag(data: CreateTagRequest): Promise<APIResponseType<Tag>> {
    try {
      const response = await apiService.post<APIResponseType<Tag>>(
        this.ENDPOINT,
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async updateTag(id: string, data: UpdateTagRequest): Promise<APIResponseType<Tag>> {
    try {
      const response = await apiService.put<APIResponseType<Tag>>(
        `${this.ENDPOINT}/${id}`,
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async deleteTag(id: string): Promise<APIResponseType<any>> {
    try {
      const response = await apiService.delete<APIResponseType<any>>(
        `${this.ENDPOINT}/${id}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default TagApiService; 